import { render, staticRenderFns } from "./FormClinic.vue?vue&type=template&id=29332699"
import script from "./FormClinic.vue?vue&type=script&lang=js"
export * from "./FormClinic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports